export default __webpack_public_path__ + "static/media/figuremap40.ba0df87d.png";